import { Card, Segmented, Typography } from "antd";
import { useState, useEffect } from "react";
import { Outlet, useLoaderData, useLocation, useNavigate, useParams } from "react-router-dom";
import { WebActivityInfoCtx } from "../../webInterface";
import { CalendarOutlined, UserOutlined, EnvironmentOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface NavLink {
    label: string;
    value: string;
}

const WebActivityLayout: React.FC = () => {
    const {id} = useParams()
    const data = useLoaderData() as WebActivityInfoCtx

    const [navLinks] = useState<NavLink[]>([
        {
            label: "Tournament Info",
            value: "info"
        },
        {
            label: "Categories",
            value: "categories"
        },
        {
            label: "Participants",
            value: "participants"
        }
    ])
    const [navValue, setNavValue] = useState("info")

    const navigate = useNavigate()
    const location = useLocation();
    const { pathname } = location;

    useEffect(() => {
        const currentPath = pathname.split('/').pop() || '';
        
        const matchedLink = navLinks.find(link => link.value.toLowerCase() === currentPath.toLowerCase());
        console.info(matchedLink)
        
        if (matchedLink) {
            setNavValue(matchedLink.value);
        } else {
            setNavValue('info');
        }
    }, [pathname, navLinks]);

    const changeNav = (value: string) => {
        console.info("update value", value)
        setNavValue(value)
        navigate(`/web/activity/${id}/${value}`);
    }


    return <>
        <Card>
            <Title level={4}>{ data.activity.name }</Title>
            <Text><EnvironmentOutlined /> {data.activity.options?.location}</Text><br />
            <Text><CalendarOutlined /> {data.activity.start_at} ~ {data.activity.end_at}</Text><br />
            <Text><UserOutlined /> {data.activity.participant_count} Participants</Text><br />
        </Card>
        <div style={{marginBottom: "20px", background: "#fff", padding: "5px"}}>
            <Segmented value={navValue} options={navLinks} onChange={changeNav} block />
        </div>

        <Outlet context={data} />
    </>
}

export default WebActivityLayout;